import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

export default function News() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-12 py-24">
      <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-5">
        News & Press
      </div>
      <h1
        className="text-5xl md:text-7xl font-black tracking-tighter leading-[0.95] mb-16"
        style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
      >
        As featured in<br />
        the <span className="text-[#2BA84A]">press</span>.
      </h1>

      <div className="grid md:grid-cols-2 gap-6">
        {items.map((n, i) => (
          <article
            key={n.id}
            className={`group flex flex-col border border-white/10 hover:border-[#F26A1F]/60 transition-colors bg-black ${
              i === 0 ? "md:col-span-2" : ""
            }`}
          >
            <div className={`relative overflow-hidden ${i === 0 ? "aspect-[16/7]" : "aspect-[16/10]"}`}>
              <img
                src={n.image_url}
                alt={n.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute top-4 left-4 px-3 py-1 bg-black/80 text-[10px] uppercase tracking-[0.2em] text-[#F26A1F] font-bold">
                {n.category}
              </div>
              {n.source && (
                <div className="absolute top-4 right-4 px-3 py-1 bg-[#2BA84A]/90 text-[10px] uppercase tracking-[0.15em] text-white font-bold">
                  {n.source}
                </div>
              )}
            </div>
            <div className="p-6 flex flex-col flex-1">
              <h2
                className={`font-bold tracking-tight mb-3 ${i === 0 ? "text-3xl" : "text-xl"}`}
                style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
              >
                {n.title}
              </h2>
              <p className="text-white/60 text-sm leading-relaxed mb-3">{n.excerpt}</p>
              <p className="text-white/70 text-sm leading-relaxed flex-1">{n.body}</p>
              {n.source_url && (
                <a
                  href={n.source_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-[#F26A1F] hover:text-white transition-colors w-fit"
                >
                  Read original on {n.source} <ExternalLink size={12} />
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
